module.exports = __webpack_public_path__ + "static/media/Zoom_Out@2x.8ee8cefb.png";